import React, { useEffect, useState } from 'react'
import { listNotifications, markNotificationRead, NotificationOut } from '../services/notificationService'

const Notifications: React.FC = () => {
  const [notifications, setNotifications] = useState<NotificationOut[]>([])
  const [loading, setLoading] = useState(true)

  const tenant = localStorage.getItem('currentTenant')
  const user = localStorage.getItem('user')
  const tenantId = tenant ? JSON.parse(tenant).id : user ? JSON.parse(user).tenant_id : ''

  const loadNotifications = async () => {
    setLoading(true)
    try {
      const data = await listNotifications(tenantId)
      setNotifications(data)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadNotifications()
  }, [])

  const handleMarkRead = async (notificationId: string) => {
    const updated = await markNotificationRead(tenantId, notificationId)
    setNotifications((prev) => prev.map((n) => (n.id === updated.id ? updated : n)))
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="mx-auto max-w-3xl bg-white rounded-lg shadow p-4">
        <h2 className="text-lg font-semibold mb-4">Notifications</h2>
        {loading ? (
          <div className="text-sm text-gray-500">Loading notifications...</div>
        ) : notifications.length === 0 ? (
          <div className="text-sm text-gray-500">No notifications yet.</div>
        ) : (
          <ul className="space-y-3">
            {notifications.map((n) => (
              <li key={n.id} className={`rounded border px-3 py-2 ${n.is_read ? 'bg-white' : 'bg-green-50 border-green-200'}`}>
                <div className="text-sm font-medium">{n.title}</div>
                {n.body && <div className="text-sm text-gray-600">{n.body}</div>}
                <div className="text-xs text-gray-400">{new Date(n.created_at).toLocaleString()}</div>
                {!n.is_read && (
                  <button className="mt-2 text-xs text-green-700" onClick={() => handleMarkRead(n.id)}>
                    Mark read
                  </button>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default Notifications
